import { Award } from 'lucide-react'
import {iconForName} from "@/components/common/iconByName.tsx";
import type {StatusLevelModel} from "@/api/model";

/**
 * Icon for a status level — uploaded image (iconUrl), otherwise the lucide icon
 * mapped from iconName, with colorHex applied. Falls back to Award (medal) when
 * no icon is set.
 */
export function StatusLevelIcon({
                                  level,
                                  className = 'size-4',
                                }: {
  level: Pick<StatusLevelModel, 'iconUrl' | 'iconName' | 'colorHex'>
  className?: string
}) {
  if (level.iconUrl) {
    return <img src={level.iconUrl} alt="" className={`${className} object-contain`} />
  }
  const Icon = iconForName(level.iconName, Award)
  return <Icon className={className} style={level.colorHex ? { color: level.colorHex } : undefined} />
}
